module.exports = __webpack_public_path__ + "img/icon-tasks.76fd4cb5.svg";